/**
 * Shared helpers for interpreting an explainability agg response.
 *
 * Lives in its own module so both the page and the table can use the same
 * definition of "this balance date has forecast data" without importing each
 * other.
 */

/** Synthetic parent row aggregating the post-process contributions. */
export const POST_PROCESS_PARENT_METRIC = 'post_process_contributions';

/**
 * Insight types the decomposition table renders as rows, excluding the
 * synthetic parent row which is computed rather than returned by the API.
 */
export function resolveTableMetricColumns(finalColumns: string[], postProcessColumns: string[]): string[] {
    return [...finalColumns, ...postProcessColumns].filter((column) => column !== POST_PROCESS_PARENT_METRIC);
}

/**
 * Balance dates carrying at least one table metric, sorted ascending.
 *
 * The agg response covers every date that has *any* insight. For a model run
 * that also publishes pre-forecast insights (recent actuals) that includes
 * dates with no forecast rows at all, which must not become table columns. A
 * value of `0` counts as present; only `undefined`/`null` are treated as absent.
 */
export function resolveDatesWithTableMetrics(data: any[], finalColumns: string[], postProcessColumns: string[]): string[] {
    const columns = resolveTableMetricColumns(finalColumns, postProcessColumns);
    const dates = data
        .filter((row) => columns.some((column) => row[column] !== undefined && row[column] !== null))
        .map((row) => row.balanceDate);
    return [...new Set(dates)].sort();
}
